import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-454d220a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__banner-fade" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  class: "d-flex align-items-center d-lg-none ms-n3 me-1",
  title: "Show aside menu"
}
const _hoisted_4 = {
  class: "btn btn-icon btn-active-light-primary",
  id: "kt_aside_mobile_toggle"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2x mt-1" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex align-items-center flex-grow-1 flex-lg-grow-0"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "d-lg-none"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "media/logos/traravico-logo.svg",
    class: "h-30px"
  })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "header__page-toolbar flex-grow-1 min-w-0 me-2 me-lg-4"
}
const _hoisted_10 = { class: "d-flex align-items-stretch flex-shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_PageToolbarHeader = _resolveComponent("PageToolbarHeader")!
  const _component_KTTopbar = _resolveComponent("KTTopbar")!
  const _directive_exclude_tab_order = _resolveDirective("exclude-tab-order")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    id: "kt_header",
    class: _normalizeClass(["header align-items-stretch", {
      'header--page-toolbar': _ctx.showPageToolbar,
      'header--page-banner': _ctx.hasHeaderBanner,
    }])
  }, [
    (_ctx.showPageToolbar)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["header__banner", { 'header__banner--image': _ctx.hasHeaderBanner }]),
          style: _normalizeStyle(_ctx.bannerStyle),
          "aria-hidden": "true"
        }, _hoisted_2, 6))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([{
        'container-fluid': _ctx.headerWidthFluid,
        'container-xxl': !_ctx.headerWidthFluid,
      }, "header__inner d-flex align-items-center justify-content-between"])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs015.svg" })
          ])
        ])
      ]),
      (!_ctx.showPageToolbar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
        : _createCommentVNode("", true),
      (_ctx.showPageToolbar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_PageToolbarHeader, { "hide-back": _ctx.hideBack }, null, 8, ["hide-back"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_KTTopbar)
      ])
    ], 2)
  ], 2)), [
    [_directive_exclude_tab_order]
  ])
}